const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="M0 0h56v56H0z" />
        <path
            d="M28.5 41.548c-1.764 0-3.194 1.445-3.194 3.226 0 1.782 1.43 3.226 3.194 3.226s3.194-1.444 3.194-3.226c0-1.781-1.43-3.226-3.194-3.226m-6.571-21.875c0 1.396-1.104 2.527-2.465 2.527-1.36 0-2.464-1.131-2.464-2.527 0-7.332 6.563-12.868 13.778-11.45 4.506.886 8.122 4.547 9 9.127 1.065 5.548-1.796 10.879-6.708 13.04-1.266.556-2.104 1.927-2.104 3.457v1.949c0 1.395-1.104 2.527-2.465 2.527-1.36 0-2.464-1.132-2.464-2.527v-1.949c0-3.508 1.971-6.731 5.09-8.103 2.808-1.235 4.424-4.246 3.815-7.418-.489-2.551-2.552-4.64-5.093-5.14a6.595 6.595 0 00-7.92 6.487z"
            fill="currentColor" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=question.es.nuW4smuq.js.map
